









import { defineComponent, PropType, ref } from "@vue/composition-api";
import { InputPayeeInformation, PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { systemName, formFields } from "./config";

export default defineComponent({
  name: "BankPayout",
  components: { BaseForm },
  props: {
    savedValues: { type: Object as PropType<Partial<InputPayeeInformation>>, required: true },
    payeeInformation: { type: Object as PropType<PayeeInformation | null> },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      nameOnAccount: props.savedValues.bank?.nameOnAccount || props.payeeInformation?.bank?.nameOnAccount || undefined,
      bankName: props.savedValues.bank?.bankName || props.payeeInformation?.bank?.bankName || undefined,
      bankAddress: props.savedValues.bank?.bankAddress || props.payeeInformation?.bank?.bankAddress || undefined,
      bankAccountNumber:
        props.savedValues.bank?.bankAccountNumber || props.payeeInformation?.bank?.bankAccountNumber || undefined,
      bankRouting: props.savedValues.bank?.bankRouting || props.payeeInformation?.bank?.bankRouting || undefined,
      accountDetails:
        props.savedValues.bank?.accountDetails || props.payeeInformation?.bank?.accountDetails || undefined,
    });

    const sendInput = () => {
      const data: Partial<InputPayeeInformation> = {
        [systemName]: {
          nameOnAccount: values.value.nameOnAccount || "",
          bankName: values.value.bankName || "",
          bankAddress: values.value.bankAddress || "",
          bankAccountNumber: values.value.bankAccountNumber || "",
          bankRouting: values.value.bankRouting || "",
          accountDetails: values.value.accountDetails || "",
        },
      };
      emit("input", data);
    };

    const input = (newValues: FormValues) => {
      values.value = newValues;
      sendInput();
    };

    sendInput();

    return { values, formFields, input };
  },
});
